import { createFileRoute } from '@tanstack/react-router'
import { PromotionsPage } from '@/features/promotions/pages/PromotionsPage'

export const Route = createFileRoute('/_app/promotions/')({
  component: PromotionsPage,
})
